<template>
  <div id="need-map"></div>
</template>
<script>
export default {
  name: "need-map",
  data() {
    return {};
  },
};
</script>
<style  scoped>
</style>